// Admins only: take a song out of the stream now (even while it plays). Its unfinished slots become
// Wizard songs for every listener; the author is emailed the reason.
import { useState } from "react";
import { ApiError, api } from "../api";

export function RemoveSongButton({ loopId, onRemoved }: { loopId: string; onRemoved?: () => void }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  if (!open)
    return (
      <button type="button" className="btn btn-ghost danger" onClick={() => setOpen(true)} data-testid="admin-remove">
        Remove now (admin)
      </button>
    );
  return (
    <form
      className="stack admin-remove"
      onSubmit={async (e) => {
        e.preventDefault();
        setBusy(true);
        setMsg("");
        try {
          const r = await api<{ replaced: { day: number; slot: number }[] }>(
            "POST",
            `/api/admin/loops/${encodeURIComponent(loopId)}/remove`,
            { reason },
          );
          setMsg(
            r.replaced.length
              ? `Removed: ${r.replaced.length} play${r.replaced.length === 1 ? "" : "s"} replaced by Wizard songs.`
              : "Removed (it had no plays left).",
          );
          onRemoved?.();
        } catch (err) {
          setMsg(err instanceof ApiError ? err.message : "Couldn't remove the song.");
        } finally {
          setBusy(false);
        }
      }}
    >
      <label className="stack-label">
        <span>Reason (sent to the author)</span>
        <input
          type="text"
          value={reason}
          maxLength={500}
          onChange={(e) => setReason(e.target.value)}
          placeholder="e.g. offensive title"
          data-testid="admin-remove-reason"
        />
      </label>
      <div className="row">
        <button type="submit" className="btn btn-primary danger" disabled={busy} data-testid="admin-remove-confirm">
          Remove for everyone
        </button>
        <button type="button" className="btn btn-ghost" onClick={() => setOpen(false)} disabled={busy}>
          Cancel
        </button>
      </div>
      {msg && <p role="status">{msg}</p>}
    </form>
  );
}
